import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { flexibleFormRelatedAgreements } from "../../store/flexible";
import { FlexBanner } from "./FlexBanner";

export const FlexCoverageDecisionMessage = () => {
	const { data: agreements } = useRecoilValue(flexibleFormRelatedAgreements);
	const { t } = useTranslation();
	const tags = [...new Set(agreements?.flatMap((a) => a.agreement.tags).flatMap((t) => t.name))].join(", ");

	return <>{agreements?.length ? <FlexBanner text={`${tags} ${t("request-for-coverage-decision-disclaimer")}`} /> : <></>}</>;
};
